import { StyleSheet } from 'react-native';

import { Colors, Fonts, Metrics } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  container: {
    flex: 1,
    overflow: 'hidden',
  },
  flatListStyle: {
    flexDirection: 'column',
    alignItems: 'center',
  },
  headerTitle: {
    fontWeight: Fonts.style.h2.fontWeight,
    fontSize: 28,
    marginBottom: Metrics.doubleBaseMargin,
    lineHeight: 37.4,
    letterSpacing: 0,
    color: Colors.dark_grey,
  },
  errorBackgroundStyle: { backgroundColor: 'transparent ', height: 200 },
  errorIconStyle: { marginTop: 10 },
  errorTextStyle: { marginTop: 16.7, marginBottom: -2 },
  containerStyle: theme => ({
    flex: 1,
    backgroundColor: theme.colors.tintColor,
    borderTopRightRadius: 10,
    borderTopLeftRadius: 10,
    borderBottomRightRadius: 10,
    borderBottomLeftRadius: 10,
    overflow: 'hidden',
    shadowColor: Colors.black,
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.16,
    shadowRadius: 8,
    elevation: 1,
  }),
  videoTextContainer: {
    flex: 1,
  },
  textContainer: {
    paddingHorizontal: 15,
    paddingVertical: 15,
  },
  header: theme => ({
    color: theme.colors.cardHeaderTitleColor,
    fontFamily: Fonts.type.VFFont,
    fontSize: 16.6,
    lineHeight: 22.9
  }),
  text: theme => ({
    color: theme.colors.headerColor,
    fontFamily: Fonts.type.bold.fontFamily,
    fontWeight: Fonts.type.bold.fontWeight,
    fontSize: 25,
    lineHeight: 29.1,
  })
});
